var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoWrapper in"},[_c('video',{ref:"audioPlayer",staticClass:"video-js vjs-audio-only-skin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }